import { render, staticRenderFns } from "./TimeAgo.vue?vue&type=template&id=1ea5cacf&scoped=true&"
import script from "./TimeAgo.vue?vue&type=script&lang=js&"
export * from "./TimeAgo.vue?vue&type=script&lang=js&"
import style0 from "./TimeAgo.vue?vue&type=style&index=0&id=1ea5cacf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5cacf",
  null
  
)

export default component.exports